module.exports = __webpack_public_path__ + "img/bg_stay_red_package.863519f0.png";